export const estimatesState = {
  form: {
    completions: '',
    interviewLength: '',
    fieldLength: '',
    incidence: '',
    questions: {},
    quotas: {},
    pii: false
  },
  results: null,
  completions: null,
  queryLoading: false
}

const estimatesReducer = (state = estimatesState, action) => {
  switch (action.type) {
    case 'SET_ESTIMATES':
      return { ...state, results: action.value }
    case 'SET_FORM':
      return { ...state, form: action.value }
    case 'ESTIMATES_LOADING':
      return { ...state, queryLoading: true }
    case 'ESTIMATES_FINISHED':
      return { ...state, queryLoading: false }
    default:
      return state
  }
}

export default estimatesReducer



// WEBPACK FOOTER //
// ./src/reducers/estimatesReducer.js